export const HelpDeskApiUrls = {
  getMyHelpRequests: "helpdesk/GetMyHelpRequests",
  createHelpRequest: "helpdesk/CreateHelpRequest",
};

export default class helpDeskAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getMyHelpRequests(data, token) {
    return this.get(HelpDeskApiUrls.getMyHelpRequests, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
